// extracted by mini-css-extract-plugin
export default {"heatload":"GeneralInfo_heatload__Yn8HP"};